var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 500,
    viewBox: "0 0 462 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45869 380.486C75.5239 495.66 227.311 530.607 342.486 458.541C457.66 386.476 492.607 234.689 420.541 119.514C348.476 4.34019 196.689 -30.6066 81.5145 41.4586",
    stroke: "#EFF3F9",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportBg);
export default __webpack_public_path__ + "static/media/passport-bg.e58bce5179bb50012216121af12e3c66.svg";
export { ForwardRef as ReactComponent };